

module.exports = __webpack_require__.stylable.create(
    "Dropdown4252634163",
    {"classes":{"root":"Dropdown4252634163__root","showPointer":"Dropdown4252634163__showPointer"},"vars":{},"stVars":{},"keyframes":{}},
    ".Dropdown4252634163__showPointer{cursor:pointer}.Dropdown4252634163__showPointer.Dropdown4252634163--noBorder{border:0}",
    1,
    "Dropdown4252634163",
    __webpack_require__.stylable.$
);
